import { authGuard } from '@auth0/auth0-vue';
import { RouteNames } from '@/data/routes';
import EmbedHowItWorksPage from '@/pages/embed/EmbedHowItWorksPage.vue';
import { createRoutes } from '@/utils/router-helper';

export default createRoutes({
  path: '/how-it-works',
  name: RouteNames.HOW_IT_WORKS.INDEX,
  component: EmbedHowItWorksPage,
  beforeEnter: authGuard,
  meta: {
    displayNav: true,
  },
});
